<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card  v-can="'view-project-brief'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>

              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                        :options="['Submitted', 'In-Progress', 'Approved by NPD', 'Approved by Sales', 'Completed']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>

          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card v-can:any="['view-project-brief', 'create-project-brief', 'edit-project-brief']" title="PROJECT BRIEF" >
          <template slot="actions">
            <vs-button v-can="'create-project-brief'" @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
<!--            <vs-input v-can="'view-project-brief'" icon-pack="feather" icon="icon-search" placeholder="Search"-->
<!--                      v-model="filters['search']"-->
<!--                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />-->
            <vs-table v-can="'view-project-brief'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">PROJECT BRIEF CODE</vs-th>
                <vs-th sort-key="name">NAME</vs-th>
<!--                <vs-th sort-key="contact_1">ACTIVE STATUS</vs-th>-->
                <vs-th sort-key="email">STATUS</vs-th>
                <vs-th v-can="'edit-project-brief'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr  @click.native="onClickCustomerSiteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].project_brief_code">
                    {{ data[indextr].project_brief_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>

<!--                  <vs-td :data="data[indextr].is_active">-->
<!--                    <vs-chip transparent :color="data[indextr].is_active ? 'primary' : 'danger'">-->
<!--                      {{ data[indextr].is_active ? 'Active' : 'De-Active' }}-->
<!--                    </vs-chip>-->
<!--                  </vs-td>-->

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" transparent :color="projectBriefColorFactory(tr.status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td v-can="'edit-project-brief'">
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-project-brief'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-project-brief-pop-up ref="createCustomerProjectBriefPopUp"/>
    <update-customer-project-brief-pop-up ref="updateCustomerProjectBriefPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/CreateCustomerProjectBriefPopUp'
  import UpdateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/UpdateCustomerProjectBriefPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerProjectBriefPopUp,
      UpdateCustomerProjectBriefPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        try {
          const {data} = await CustomerRepository.getProjectBriefs(this.page, this.filterQuery, 10, this.sort)
          this.staff =  data.data
          this.meta = data.meta
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerProjectBriefPopUp.openPopup()
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerProjectBriefPopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.page = 1
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page = page;
        this.loadStaff()
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return '#a0937d';
          case 2:
            return 'primary';
          case 3:
            return 'success';
          case 4:
            return 'warning';
          case 5:
            return '#00adb5';
        }
      }

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
